import React, {Component} from 'react'
import PropTypes          from 'prop-types'
import HorizontalSlider   from '../horizontal-slider'
import cn                 from 'classnames'
import Audio              from './audio'
import PlaylistManager    from './playlist-manager'
import { getFreeSong , getAlbumById} from '../../drawer-items'
import {setCurrentTrack}  from '../../currentDate'
import {getAlbumInfoById, getTrackById, hasAuth} from '../../services/api'
import { loadFreeTracks } from '../../actions/tracks'
import WidgetInfo from '../widget/widgetInfo'
import store from '../../store'
import { getCachedImageUrl } from '../../services/image-cache'
import { RadioButton } from '../../drawer-front'
import LiveRadio from '../radio/live-radio'

export class Rotator extends Component {
    render() {
        let {amount, offset} = this.props
        offset = offset || 0
        let degrees = ((amount + offset)* 90) - 45
        let style = {transform: `rotate(${degrees}deg)`}
        return (
            <div className="rotator" style={style}>{this.props.children}</div>
        )
    }
}

function formatClock(seconds) {
    if (isNaN(seconds)) return "--:--"
    return Math.floor(seconds / 60) + ':' + ('0' + Math.floor(seconds % 60)).slice(-2)
}

export function bitrate_to_value(b) {
    let r
    //0 to 800 first half
    if (b <= 800) {
        r = (b / 800) * 0.5
    //800 to 6000 next 1/3
    } else if (b <= 6000) {
        r = ((b - 800) / (6000 - 800)) * (0.6666 / 2) + 0.5
    //6000 to 7000 last 1/6
    } else {
        r = (b - 6800) / (7000 - 6800) * (0.3333 / 2) + (0.5 + (0.6666 / 2))
    }
    return Math.max(0, Math.min(1.0, r))
}

export function fmt_1000(n) {
    if (n < 10) return '00' + n
    if (n < 100) return '0' + n
    return '' + n
}

export function fmt_bitrate(b){
    if (typeof b !== 'number') return b
    if (b < 1000) return b
    return Math.floor(b / 1000)  + ',' + fmt_1000(b % 1000)
}

export class Meter extends Component {
    render(){
        let {bitrate, level, radio, readout, unit} = this.props
        let angle = typeof level === 'number' ? level : bitrate_to_value(bitrate)
        if (readout === undefined) readout = bitrate == null ? '' : fmt_bitrate(bitrate)
        return (
            <div className={cn('meter', {radio})}>
              <div className="arc-mask">
                <Rotator amount={angle} offset={-0.5}><div className="meter-arc" /></Rotator>
              </div>
              <div className="meter-top"/>
              <Rotator amount={angle}><div className="meter-needle" /></Rotator>
              {unit && <div className="unit">{unit}</div>}
              <div className="readout">{readout}</div>
              <div className="meter-bottom" />
            </div>
        )
    }
}


export class RadioMeter extends Component {
    constructor(props){
        super(props)
        this.state = { level: LiveRadio.getLevel() }
    }
    componentDidMount(){
        this.timer = setInterval(() => {
            this.setState({ level: LiveRadio.getLevel() })
        }, 1000 / 12)
    }
    componentWillUnmount(){
        clearInterval(this.timer)
    }
    render(){
        return <Meter radio level={this.state.level || 0} readout="" />
    }
}

export class PlayerControls extends Component {
    shouldComponentUpdate(newprops){
        return newprops.playing !== this.props.playing ||
               newprops.loading !== this.props.loading ||
               newprops.prevDisabled !== this.props.prevDisabled ||
               newprops.nextDisabled !== this.props.nextDisabled ||
               newprops.disabled !== this.props.disabled ||
               newprops.onPlayPause !== this.props.onPlayPause ||
               newprops.onPrev !== this.props.onPrev ||
               newprops.onNext !== this.props.onNext
    }
    render(){
        let {playing, loading,  disabled, prevDisabled, nextDisabled, isEmbed, isTrack, isNavbarEmbed} = this.props
        let controls = cn('player-controls', {disabled})
        if(isEmbed && !isNavbarEmbed)controls += ' isEmbed'

        let play = !loading && !playing
        let pause = !loading && playing

        let prevClass = cn('prev-button', {disabled: disabled || prevDisabled})
        let nextClass = cn('next-button', {disabled: disabled || nextDisabled})

        let cx = cn('play-pause-button', {play, pause, loading, disabled})

        return (
            <div className={controls}>
              <div className={prevClass} onClick={this.props.onPrev} />
              <div className={cx} onClick={this.props.onPlayPause} />
              {loading && <div className="loading-indicator-wrapper"><div className="loading-indicator" /></div> }
              <div className={nextClass} onClick={this.props.onNext} />
            </div>
        )
    }
}

export class VolumeControl extends HorizontalSlider {

    render(){
        let pct = this.unscale(this.props.pct)
        let pStyle = { width: `${pct}%` }
        return (
            <div className="volume-control">
              <div className="slider-background" />
              <input className="volume-thumb" style={{ backgroundSize: this.state.volumePct + '%' +'100%'}} type="range" min={0} max={100} value={this.state.volumePct} onChange={((e)=>{this.handleVolumeChange(e)})}/>
            </div>
        )
    }
}

export class ScrubControl extends HorizontalSlider {
    render(){

        let progress = this.unscale(this.props.pct) + '%'
        const { disableScrub = false} = this.props;

        return (
            <div ref="line" className="progress-bar">
              <div className={disableScrub ? "progress innactive" : "progress"} style={{width:progress}}>
                <div className="black-bar" />
                <div ref="thumb" className="thumb"
                     onMouseDown={disableScrub ? null : this.mouseDown} onTouchStart={disableScrub ? null : this.touchStart}>
                  <div className="black-thumb" />
                </div>
              </div>
            </div>
        )
    }
}

export default class Player extends Component {
  constructor(a, b) {
    super(a, b);

    const { pathname = "", query = {}, search = "" } = this.props.location || {};
    const isEmbed = pathname.includes("embed");

    let isNavbarEmbed = false;

    if (query.navbar === 'true' || query.navbar === true) {
      isNavbarEmbed = true;
    }

    if (search) {
      const urlParams = new URLSearchParams(search);
      if (urlParams.get('navbar') === 'true') {
        isNavbarEmbed = true;
      }
    }

    if (typeof window !== 'undefined' && window.location.search.includes('navbar=true')) {
      isNavbarEmbed = true;
    }
    

    


    let track = PlaylistManager.currentTrack();
    let { prevDisabled, nextDisabled } =
      PlaylistManager.prevNextDisabled(isEmbed && !isNavbarEmbed);

    const { status: radioStatus, track: radioTrack } = LiveRadio.getState();

    this.state = {
      track,
      prevDisabled,
      nextDisabled,
      radioStatus,
      radioTrack,
      volume: 100,
      playing: false,
      loading: false,
      state: null,
      samprate: 0,
      bitrate: 0,
      position: 0,
      elapsed: "--:--",
      remaining: "--:--",
      view: "initial",
      isTrack: false,
      isEmbed,
      isNavbarEmbed,
      playEmbed: false,
      mainPlayer: true,
    };
    this.setVolume = this.setVolume.bind(this);
    this.playPause = this.playPause.bind(this);
    this.callback = this.callback.bind(this);
    this.playlistCallback = this.playlistCallback.bind(this);
    this.loadSOD = this.loadSOD.bind(this);

    this.scrubDragStart = this.scrubDragStart.bind(this);
    this.scrubDragMove = this.scrubDragMove.bind(this);
    this.scrubDragEnd = this.scrubDragEnd.bind(this);

    this.clickArt = this.clickArt.bind(this);
    this.clickTrack = this.clickTrack.bind(this);

    this.onKeyPress = this.onKeyPress.bind(this);

    this.pauseIfNeeded = this.pauseIfNeeded.bind(this);
    this.resumeIfNeeded = this.resumeIfNeeded.bind(this);
    this.toggleView = this.toggleView.bind(this);
    this.redirection = this.redirection.bind(this);
    this.playTrackInAlbum = this.playTrackInAlbum.bind(this);
    this.onRadioStateChange = this.onRadioStateChange.bind(this);

    window.pauseAudioIfNeeded = this.pauseIfNeeded;
    window.resumeAudioIfNeeded = this.resumeIfNeeded;
  }
  componentDidMount() {
    const { query = {} } = this.props.location || {};
    const urlParams = new URLSearchParams(window.location.search);
    const trackId = query.trackId || query.track || urlParams.get('trackId') || urlParams.get('track') || false;
    const albumId = query.albumId || query.album || urlParams.get('albumId') || urlParams.get('album') || false;
    const navbar = query.navbar || urlParams.get('navbar') || false;
    
    const { isEmbed, isNavbarEmbed } = this.state;
    const id = trackId || albumId;
    const isTrack = trackId ? true : false;
    
    //############## Get track information #######################

    if (isTrack !== this.state.isTrack) {
      this.setState({ isTrack });
    }

    if (isEmbed && !isNavbarEmbed) {
      this.handleEmbed(isTrack, id);
    } else if (isNavbarEmbed) {
      
      if (id) {
        this.handleEmbed(isTrack, id);
      } else {
        if (!this.state.track) {
          let track = getFreeSong();
          this.setState({ track, SOD: true }); 
        }
      }
    } else {
      if (!this.state.track) {
        let track = getFreeSong();
        this.setState({ track, SOD: true });
      }
      if (this.state.track) {
        PlaylistManager.playTrack(this.state.track);
      }
    }
    Audio.addCallback(this.callback);
    PlaylistManager.addListener(this.playlistCallback);
    document.addEventListener("keypress", this.onKeyPress);
    this.unsubscribeRadio = LiveRadio.onStateChange(this.onRadioStateChange);
  }
  onRadioStateChange({ status, track }) {
    this.setState({ radioStatus: status, radioTrack: track });
    const active = status === "connecting" || status === "playing";
    if (active && !this.radioTickInterval) {
      // elapsed/remaining are derived from wall-clock time against
      // track.startedAt/endsAt, not from any player event, so nothing else
      // triggers a re-render for them to tick.
      this.radioTickInterval = setInterval(() => this.forceUpdate(), 1000);
    } else if (!active && this.radioTickInterval) {
      clearInterval(this.radioTickInterval);
      this.radioTickInterval = null;
    }
  }
  componentWillUnmount() {
    Audio.removeCallback(this.callback);
    PlaylistManager.removeListener(this.playlistCallback);
    if (this.unsubscribeRadio) this.unsubscribeRadio();
    if (this.radioTickInterval) clearInterval(this.radioTickInterval);
    document.removeEventListener("keypress", this.onKeyPress);
    if (this.loadingTimeout) {
      clearTimeout(this.loadingTimeout);
    }
  }
  async handleEmbed(isTrack, id) {
    let track = {};
    let album = {};
    const { isNavbarEmbed } = this.state;

    if (isTrack && id) {
      const trackInfo = await getTrackById(id);
      let selectedTrack = trackInfo && trackInfo.track ? [trackInfo.track] : {};
      if (selectedTrack && selectedTrack[0]) {
        let preview = selectedTrack[0].hasOwnProperty("preview")
          ? selectedTrack[0].preview
          : true;
        selectedTrack[0].preview = preview;
        selectedTrack[0].isEmbed = true;
      }

      loadFreeTracks(selectedTrack);
      track = selectedTrack[0];
    } else if (id) {
      try {
        const albumInfo = await getAlbumInfoById(id);
        
        if (albumInfo && albumInfo.album) {
          const { album: albumData } = albumInfo;
          track = albumData.tracks && albumData.tracks[0] ? albumData.tracks[0] : null;
          album = albumData;
        
        } 
      } catch (error) {
        console.error('💿 Album API error:', error);
      }
    }

    this.setState({
      track,
      SOD: isNavbarEmbed ? false : true,
      playEmbed: !isNavbarEmbed, 
      isTrack,
      album,
      mainPlayer: isNavbarEmbed ? true : false,
    });
    
    if (isNavbarEmbed && (track || album)) {
      const attemptPlayback = () => {
        if (album && album.tracks && album.tracks.length > 0) {
          
          PlaylistManager.playAlbum(album, true);
        } else if (track) {
          PlaylistManager.playTrack(track);
        } 
      };
      setTimeout(attemptPlayback, 100);
    } 
  }
  

  loadSOD() {
    const { isEmbed, isTrack, album, SOD, track: stateTrack } = this.state;

    // FIX: Don't run loadSOD for concert tracks
    if (
      stateTrack &&
      (stateTrack.isConcert || (stateTrack.album && stateTrack.album.isConcert))
    ) {
      return;
    }
    
    let view = "initial";
    if (document.readyState) {
      //check if user is already logged in
      if (isEmbed && !hasAuth()) {
        view = "login";
      }
      this.setState({
        SOD: false,
        playEmbed: false,
        view,
        sodLoaded: SOD,
        repeatSong: false,
      });
      
    
      if ((isEmbed && !isTrack && album) || (album && !isEmbed)) {
        if (album && album.tracks && album.tracks.length > 0) {
          PlaylistManager.playAlbum(album, true);
        }
        return;
      }
      let track = stateTrack ? stateTrack : getFreeSong();
      if (track) {
        PlaylistManager.playTrack(track);
      }
    }
  }
  onKeyPress(e) {
    let { location } = this.props;
    const currentLocation = location.pathname;
    if (
      e.target.tagName === "INPUT" ||
      e.target.tagName === "TEXTAREA" ||
      currentLocation.includes("/movie-night") ||
      currentLocation.includes("/video")
    )
      return;
    if (e.code === "Space") {
      if (LiveRadio.isPlaying()) LiveRadio.stop();
      else if (this.state.track) this.playPause();
    }
  }
  playlistCallback(info) {
    if (
      (info.state === "STOPPED" &&
        !this.state.playEmbed &&
        this.state.isTrack) ||
      (this.state.mainPlayer && info.state === "STOPPED")
    ) {
      const playEmbed = this.state.isEmbed ? true : false;
      this.setState({
        SOD: playEmbed,
        playEmbed,
        isEmbed: playEmbed,
        playing: false,
        loading: false,
        position: 0,
        elapsed: "--:--",
        remaining: "--:--",
      });
      if (this.loadingTimeout) {
        clearTimeout(this.loadingTimeout);
        this.loadingTimeout = null;
      }
      return;
    }
    if (info.state === "WILLPLAY") {
      this.setState({
        loading: true,
        track: info.track,
        prevDisabled: info.atStart,
        nextDisabled: info.atEnd,
      });
      if (this.loadingTimeout) {
        clearTimeout(this.loadingTimeout);
      }
      this.loadingTimeout = setTimeout(() => {
        this.setState({ loading: false });
        this.loadingTimeout = null;
      }, 10000); // 10 seconds
    } else if (info.state === "PAUSED") {
      this.setState({ loading: false });
      if (this.loadingTimeout) {
        clearTimeout(this.loadingTimeout);
        this.loadingTimeout = null;
      }
    } else if (info.state === "LIVEPLAY" && !this.state.playing) {
      if (this.loadingTimeout) {
        clearTimeout(this.loadingTimeout);
        this.loadingTimeout = null;
      }
      this.setState({ playing: true, loading: false, track: info.track });
    } else {
      this.setState({ track: info.track });
    }
  }
  pauseIfNeeded() {
    if (LiveRadio.isPlaying()) LiveRadio.stop();
    if (!this.state.playing) return;
    Audio.pause();
    this.setState({ playing: false, temporarilyPaused: true });
  }
  resumeIfNeeded() {
    if (!this.state.temporarilyPaused) return;
    Audio.play();
    this.setState({ playing: true, temporarilyPaused: false });
  }
  playPause() {
    let { playing, loading, position, isEmbed, isTrack, isNavbarEmbed, track } = this.state;
    
    if (isEmbed && !isNavbarEmbed && position >= 0.99 && isTrack) {
      this.loadSOD();
      return;
    }
    if (loading) return;
    playing = !playing;
    if (playing) Audio.play();
    else Audio.pause();
    this.setState({ playing });
  }
  scrubDragStart() {
    this.setState({ scrubbing: true, scrubState: this.state.position * 100 });
  }
  scrubDragMove(pct) {
    this.setState({ scrubState: pct });
  }
  scrubDragEnd() {
    const { isEmbed } = this.state;
    Audio.seek(this.state.scrubState / 100, isEmbed);
    setTimeout(() => {
      this.setState({ scrubbing: false });
      if (this.state.state === "PAUSED") {
        (this.setState({loading: true}));
        setTimeout( () => {
          Audio.play();
          this.setState({ playing: true, temporarilyPaused: false });
        }, 500);
      }
    }, 500);
  }
  setVolume(pct) {
    this.setState({ volume: pct });
    Audio.setVolume(pct / 100);
    LiveRadio.setVolume(pct / 100);
  }
  callback(playerState) {
    if (playerState.state === "PAUSED" && this.state.state === "PAUSED") {
      if (Audio.getIsFirstLoad() && playerState.duration !== "-" && !LiveRadio.isPlaying()) {
        this.setState({ loading: false, playing: true, elapsed: "00:00" });
        Audio.play();
        Audio.setIsFirstLoad(false);
        return;
      }
    }
    if (playerState.state !== this.state.state) {
    }
    if (playerState.state === "READY") {
      const { isTrack, isEmbed } = this.state;
      let repeatSong = this.state.repeatSong;
      let trackReset = this.state.track;
      let album = null;
      if (!repeatSong) {
        //not track  -> get current playlist
        repeatSong = this.state.isEmbed ? false : this.state.sodLoaded;
        if (!isTrack && !isEmbed) {
          album = { tracks: PlaylistManager.currentPlaylist() };
          trackReset = album && album.tracks[0];
          repeatSong = true;
        }
      }
      this.setState({
        state: playerState.state,
        track: trackReset,
        album,
        repeatSong,
        playing: false,
        loading: false,
        samprate: 0,
        bitrate: 0,
        position: 0,
        elapsed: "--:--",
        remaining: "--:--",
        elapsed: "--:--",
        quality,
      });
      return;
    }
    let { state, samprate, bitrate, position, elapsed, remaining, quality } =
      playerState;

    if (state === "LIVEPLAY") {
      this.setState({
        playing: true,
        loading: false,
        state,
        samprate,
        bitrate,
        position,
        elapsed,
        remaining,
        quality,
      });
    } else {
      this.setState({
        state,
        samprate,
        bitrate,
        position,
        elapsed,
        remaining,
        quality,
        playing: false,
      });
    }
  }
  clickArt() {
    let { track, isEmbed } = this.state;
    if (isEmbed) {
      this.redirection();
      return;
    }
    if (!track) return;
    let { history } = this.props;
    let album = track.album || false;

    let albumPosition = (album && getAlbumById(album.id)) || false;
    if (albumPosition) setCurrentTrack(albumPosition);

    let route = `/album?id=${album.id}`;
    if (track && track.performanceLog && track.url) return;

    history.push(route);
  }
  clickTrack(type = false) {
    let { track, isEmbed } = this.state;
    let { history } = this.props;

    if (isEmbed) {
      this.redirection(type);
      return;
    }
    if (!track || (track.listOnly && !track.outTake && !track.friendsAndFamily)) return;

    let route = (track.id && `/info-card?track=${track.id}`) || false;
    if (track && track.performanceLog && track.url) route = track.url;

    if (route) history.push(`${route}`);
  }
  toggleView(view) {
    this.setState({ view });
  }
  redirection(type) {
    let { track, isTrack, album } = this.state;
    let route = false;
    if ((track && isTrack) || type === "track") {
      const { id } = track;
      if (id)
        route =
          (id && `${process.env.SITE_URL}/info-card?track=${id}`) || false;
      if (route) window.open(route, "_blank");
    } else if (track) {
      if (album) route = `${process.env.SITE_URL}/album?id=${album.id}`;
      if (route) window.open(route, "_blank");
      return;
    } else {
      return;
    }
  }
  playTrackInAlbum(isPlaying, item) {
    const { showAreYouStillListeningModal } = this.props;
    const { album } = this.state || {};
    if (isPlaying) {
      this.playPause();
    } else {
      this.playPause();
      this.setState({ playEmbed: false });

      PlaylistManager._playItemInItems(
        item,
        album.tracks,
        album,
        showAreYouStillListeningModal
      );
    }
  }
  render() {
    let {
      volume,
      playing,
      loading,
      elapsed,
      remaining,
      bitrate,
      samprate,
      position,
      quality,
      scrubbing,
      scrubState,
      track,
      prevDisabled,
      nextDisabled,
      SOD,
      isEmbed,
      playEmbed,
      view,
      isTrack,
      album,
      repeatSong,
      radioStatus,
      radioTrack,
    } = this.state;
    const { themeAperance = "light-mode" } = this.props;
    let disabled = !track;
    const radioActive = radioStatus === "connecting" || radioStatus === "playing";

    let title,
      backgroundImage,
      performer,
      orastream,
      mp3audio,
      location,
      country,
      trackId;
    if (track) {
      title = track.title;
      backgroundImage = `url('${getCachedImageUrl(track.playerImage || track.albumImage)}')`;
      performer = track.performer;
      orastream = track.orastream;
      mp3audio = track.mp3audio;
      location = track.location;
      country = track.country;
      trackId = track.trackId;
    } else {
      title = "";
      backgroundImage = "";
      performer = "";
      orastream = false;
      mp3audio = false;
    }

    if (radioActive) {
      title = radioTrack ? radioTrack.title : "NYA Radio";
      performer = radioTrack ? radioTrack.artist : "";
      backgroundImage = radioTrack && radioTrack.albumImage
        ? `url('${getCachedImageUrl(radioTrack.albumImage)}')`
        : backgroundImage;

      if (radioTrack && radioTrack.startedAt && radioTrack.endsAt) {
        const now = LiveRadio.serverNow();
        const totalSec = Math.max(1, (radioTrack.endsAt - radioTrack.startedAt) / 1000);
        const elapsedSec = Math.min(totalSec, Math.max(0, (now - radioTrack.startedAt) / 1000));
        elapsed = formatClock(elapsedSec);
        remaining = formatClock(totalSec - elapsedSec);
        position = elapsedSec / totalSec;
      } else {
        elapsed = "--:--";
        remaining = "--:--";
        position = 0;
      }
    }

    let imageStyle = { backgroundImage };
    const previewOnlyTrack =
      track && track.preview ? (track && track.free ? false : true) : false;
    const disableScrub = radioActive ? true : (isEmbed ? previewOnlyTrack : false);

    let experienceRate = "--";
    if (samprate) {
      experienceRate = samprate.replace("b/", "bit • ");
      experienceRate += `Hz  • ${bitrate} kbps`;
    }

    let sample = samprate ? samprate.replace(/b|k/g, "") : "--";

    if (quality === 10) sample = `FULL ${sample} RESOLUTION`;

    let progress = scrubbing ? scrubState : position * 100;

    let currBitrate = bitrate_to_value(bitrate);
    let currFill = quality === 10 ? 1.0 : currBitrate;

    let onPlayPause = radioActive
      ? LiveRadio.stop
      : (disabled ? undefined : this.playPause);
    let playerType = "middle-layer";
    let playerWrapperType = "new-player-wrapper";
    const { isNavbarEmbed } = this.state;
    
    if (isEmbed) {
      if (isNavbarEmbed) {
      } else {
        playerWrapperType += isTrack ? " embed" : " embed album";
        playerType += isTrack ? "-embed" : "-embed album";
      }
    }

 
    const isConcertTrack =
      track && (track.isConcert || (track.album && track.album.isConcert));
    const shouldUseLoadSOD = !radioActive && !isConcertTrack && (
      (SOD && track && (track.free || isEmbed) && !playing) || 
      (playEmbed && !playing) || 
      repeatSong
    );
    
    if (shouldUseLoadSOD) {
      onPlayPause = this.loadSOD;
    }

    if (!Audio.getQuality()) currFill = quality / 10.0;

    let bwbgStyle = { height: currFill * 100 + "%" };

    const stripHTML = (htmlString) => {
      if (!htmlString) return "";

      // Create a temporary div to parse HTML
      const temp = document.createElement("div");
      temp.innerHTML = htmlString;

      // Return just the text content
      return temp.textContent || temp.innerText || "";
    };

    return (
      <div className={playerWrapperType}>
        <div className={`new-player ${themeAperance}${radioActive ? " radio-locked" : ""}`}>
          <div className={`currently-playing ${isEmbed && !isNavbarEmbed}`}>
          {(!isEmbed || isNavbarEmbed)  && (
              <div className="bandwidth-background-wrapper">
                <div className="bandwidth-background" style={bwbgStyle} />
              </div>
            )}

            <div
              className="info-wrapper"
              onClick={radioActive ? undefined : () => this.clickTrack("track")}
            >
              <div className="track-title">{`${stripHTML(title)}${
                location ? ` - ${location}, ${country}` : ""
              }`}</div>
              <div className="track-performer">{stripHTML(performer)}</div>
              <div className="time-indicators">
                <div className="left">{elapsed}</div>
                {!isEmbed && <div className="center">{sample}</div>}
                <div className="right">{remaining}</div>
              </div>
            </div>
            <div
              className="album-artwork"
              onClick={radioActive ? undefined : this.clickArt}
              style={imageStyle}
            />
            <ScrubControl
              dragStart={this.scrubDragStart}
              onScroll={this.scrubDragMove}
              dragEnd={this.scrubDragEnd}
              pct={progress}
              disableScrub={disableScrub}
            />
          </div>
          <div className={playerType} />
          {(!isEmbed || isNavbarEmbed) && (radioActive ? <RadioMeter /> : <Meter bitrate={bitrate} />)}
          <PlayerControls
            disabled={disabled}
            prevDisabled={radioActive || prevDisabled}
            nextDisabled={radioActive || nextDisabled}
            isEmbed={isEmbed}
            isNavbarEmbed={isNavbarEmbed}
            loading={radioActive ? radioStatus === "connecting" : loading}
            playing={radioActive || playing}
            isTrack={isTrack}
            onPlayPause={onPlayPause}
            onPrev={radioActive || disabled || prevDisabled ? undefined : Audio.prev}
            onNext={radioActive || disabled || nextDisabled ? undefined : Audio.next}
          />
          {(!isEmbed || isNavbarEmbed) && <RadioButton />}
        </div>
        {(!isEmbed || isNavbarEmbed) && <VolumeControl onScroll={this.setVolume} pct={volume} />}
        
        {/* Regular embed widget */}
        {isEmbed && !isNavbarEmbed && (
          <WidgetInfo
            bitrate={experienceRate}
            playerState={this.state.state}
            loading={loading}
            view={view}
            toggleView={this.toggleView}
            redirection={this.redirection}
            isTrack={isTrack}
            trackId={trackId}
            album={album}
            playTrackInAlbum={this.playTrackInAlbum}
          />
        )}
      </div>
    );
  }
}

Player.contextTypes = {
    router: PropTypes.object.isRequired
}
